function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "arcticons:wifiprivacy"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M8.12 13.6333C9.03138 12.3991 10.2184 11.3948 11.5864 10.7004C12.9545 10.0059 14.4658 9.64056 16 9.63333C17.5343 9.64004 19.0458 10.0052 20.4139 10.6997C21.7821 11.3942 22.969 12.3988 23.88 13.6333M10.94 15.7533C11.5147 14.9427 12.2723 14.2788 13.1514 13.8155C14.0305 13.3522 15.0064 13.1025 16 13.0867C16.9936 13.1025 17.9695 13.3522 18.8486 13.8155C19.7277 14.2788 20.4853 14.9427 21.06 15.7533M13.5667 17.72C13.8498 17.3419 14.2171 17.035 14.6395 16.8237C15.0619 16.6123 15.5277 16.5022 16 16.5022C16.4723 16.5022 16.9381 16.6123 17.3605 16.8237C17.7829 17.035 18.1502 17.3419 18.4333 17.72",
  stroke: "black",
  strokeWidth: 0.666667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M16 29C17.1267 29 26.1667 23.82 26.1667 17.7067V4.37333C23.5 4.37333 16 3.04 16 3.04C16 3.04 8.49333 4.37333 5.83333 4.37333V17.7067C5.83333 23.82 14.8733 29 16 29Z",
  stroke: "black",
  strokeWidth: 0.666667,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgWifipermit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifipermit);
export default __webpack_public_path__ + "static/media/wifipermit.186d9cf1.svg";
export { ForwardRef as ReactComponent };